import { createGlobalStyle } from 'styled-components';

const LockBodyScroll = createGlobalStyle`
  body {
    height: 100vh;
    overflow: hidden;
  }
`;

export default LockBodyScroll;
